import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CertificateService } from '@app/services/certificate.service';
import { UserCertificate } from '@app/model/user-certificate.model';
import { ProfileService } from 'library-explorer';

@Component({
    selector: 'app-certificate-preview-modal',
    templateUrl: './certificate-preview-modal.component.html',
    styleUrls: ['./certificate-preview-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CertificatePreviewModalComponent implements OnInit {

  public image?: SafeResourceUrl;
  public isLoading = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public certificate: UserCertificate,
    public dialogRef: MatDialogRef<CertificatePreviewModalComponent>,
    private readonly certificateService: CertificateService,
    private readonly profileService: ProfileService,
    private readonly sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    const userId = this.profileService.getCurrentProfileValue()?.id;

    this.certificateService.getCertificateImage(this.certificate.id, this.certificate.customCertificate.id, userId)
      .subscribe(image => {
        this.image = image;
      });
  }

  public onImageLoad(): void {
    this.isLoading = false;
  }

}
